import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-team-day-slot-card',
  templateUrl: './team-day-slot-card.component.html',
  styleUrls: ['./team-day-slot-card.component.scss']
})
export class TeamDaySlotCardComponent implements OnInit {
  @Input() teamShiftDetail: any;
  @Input() providerId: any;
  @Input() id: any;
  @Output() openShiftPopup = new EventEmitter();
  teamAvailabilityStatusColor = AppSettings.TEAM_AVAILABILITY_STATUS;
  teamShiftStatusColor = AppSettings.TEAM_SHIFT_STATUS;
  // teamUnavailabilityStatusColor = AppSettings.TEAM_UNAVAILABILITY_STATUS;
  bgCardClass = '';
  borderClass = '';
  teamSlots = [];
  displayingTeamSlot = [];

  constructor(private router: Router,  private manageOpenShiftService: ManageOpenShiftsService) { }

  ngOnInit(): void {
    this.displayingTeamSlot = this.teamShiftDetail;
    if (this.teamShiftDetail.length > 1) {
      const scheduleLength = this.teamShiftDetail[0].shiftMemberSchedules.length +
        this.teamShiftDetail[1].shiftMemberSchedules.length;
      if (scheduleLength > 4) {
        this.teamSlots = this.teamShiftDetail.slice(1);
        this.displayingTeamSlot = this.teamShiftDetail.slice(0, 1);
      } else if (this.teamShiftDetail.length > 2) {
        this.teamSlots = this.teamShiftDetail.slice(2);
        this.displayingTeamSlot = this.teamShiftDetail.slice(0, 2);
      }
    }
    this.bgCardClass =  this.manageOpenShiftService.convertToCssClass(this.teamShiftDetail?.memberStatusStr);
    this.borderClass = this.teamShiftStatusColor[this.teamShiftDetail?.openShiftRequestStatusStr] || '';
  }

  goToEdit(date) {
    this.router.navigate(['hc-providers/edit-teams'], { queryParams: { id: this.id, providerId: this.providerId }, state: { date } });
  }

  openShift() {
    const teamDetails = {
      date: this.teamShiftDetail.dateStr,
      teamName: this.id
    };
    this.openShiftPopup.emit(teamDetails);
  }

  setNotAvailableFlag(shiftMemberSchedule) {
    if (!shiftMemberSchedule) {
      return false;
    }
    if (shiftMemberSchedule.length === 0) {
      return true;
    }
    return shiftMemberSchedule.every((team) => team.startTimeStr === null && team.endTimeStr === null);
  }

}
